<template>
  <div class="flex" :class="{ 'opacity-30': email === '' && !success }">
    <input
      class="w-64 transition-opacity"
      :disabled="disabled"
      :placeholder="placeholder"
      type="email"
      v-model="email"
      @keyup.enter="handleSubmit"
    />
    <button
      class="transition-opacity"
      :class="{ 'opacity-0': !isValid }"
      @click="handleSubmit"
    >
      →
    </button>
  </div>
</template>

<script>
import addToMailingList from "@io/addToMailingList";

export default {
  name: "BlockSignUp",

  data: () => ({
    success: false,
    disabled: false,
    email: "",
    emailChangeSource: "input"
  }),

  computed: {
    placeholder() {
      return this.success ? "Received :-)" : "name@email.com";
    },
    isValid() {
      return this.isEmail(this.email);
    }
  },

  watch: {
    email() {
      if (this.emailChangeSource === "input") {
        this.success = false;
      }

      this.emailChangeSource = "input";
    }
  },

  methods: {
    isEmail(input) {
      // eslint-disable-next-line no-useless-escape
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(input).toLowerCase());
    },
    async handleSubmit() {
      if (!this.isEmail(this.email)) return;

      // Disabled state
      this.disabled = true;
      this.emailChangeSource = "click";

      const success = await addToMailingList(this.email);

      this.disabled = false;

      if (success) {
        // Sucsess
        this.success = true;
        this.email = "";
      } else {
        // Error
        // No error state provided
      }
    }
  }
};
</script>

<style scoped>
input {
  background-color: unset;
  outline: none;
  min-width: 12em;
  margin-left: 0.75em;
  text-align: inherit;
}

input::placeholder {
  color: theme(colors.egg);
}

input:disabled {
  opacity: theme(opacity.30);
}

.transition-opacity {
  transition-property: opacity;
  transition-duration: var(--transition-short);
  transition-timing-function: var(--transition-ease-out);
}
</style>
